import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0202272e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "animate modal"
}
const _hoisted_2 = { class: "form-style-10" }
const _hoisted_3 = { class: "inner-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Añadir Experiencia", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "En años en el puesto solo números enteros", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 1,
  class: "animate modal"
}
const _hoisted_9 = { class: "form-style-10" }
const _hoisted_10 = { class: "inner-wrap" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Editar Experiencia", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 2,
  class: "animate modal"
}
const _hoisted_15 = { class: "form-style-10" }
const _hoisted_16 = { class: "inner-wrap" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Añadir Estudios Previos", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "País", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Región", -1))
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 3,
  class: "animate modal"
}
const _hoisted_24 = { class: "form-style-10" }
const _hoisted_25 = { class: "inner-wrap" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Editar Estudio Previo", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "País", -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Región", -1))
const _hoisted_31 = ["value"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Mi perfil de empleo", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Aporta la mayor información posible. Mientras más completo sea tu perfil, más fácil nos será encontrarte un empleo adecuado a tus competencias.")
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_35 = { class: "main-info-container" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Información General", -1))
const _hoisted_37 = {
  key: 0,
  class: "animate main-info"
}
const _hoisted_38 = { class: "form-check" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " En búsqueda activa de empleo. ", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = { class: "form-check" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Autoinscribirme en candidaturas adecuadas. ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = { class: "form-check" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Estoy dispuesto a trabajar en remoto. ", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = { class: "form-check" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Estoy dispuesto a desplazarme. ", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Mi rango para desplazarme es:", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "local" }, "Local", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "region" }, "Regional", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "country" }, "Nacional", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "international" }, "Internacional", -1))
const _hoisted_57 = [
  _hoisted_53,
  _hoisted_54,
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Actualmente resido en:", -1))
const _hoisted_60 = { class: "selects" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "País", -1))
const _hoisted_62 = ["value"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Región", -1))
const _hoisted_64 = ["value"]
const _hoisted_65 = { key: 1 }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_67 = { class: "main-info-container" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Sobre mí", -1))
const _hoisted_69 = {
  key: 0,
  class: "animate main-info"
}
const _hoisted_70 = { class: "social-check-container2" }
const _hoisted_71 = { class: "left2" }
const _hoisted_72 = { class: "social-check" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "imputSocialSlogan"
}, " Slogan ", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_75 = { class: "social-check" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "imputSocialGitHub"
}, " Descripción ", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Actualizar", -1))
const _hoisted_79 = [
  _hoisted_78
]
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { class: "main-info-container" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Redes sociales", -1))
const _hoisted_83 = {
  key: 0,
  class: "animate main-info"
}
const _hoisted_84 = { class: "social-check-container" }
const _hoisted_85 = { class: "left" }
const _hoisted_86 = { class: "social-check" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "imputSocialInstagram"
}, " Instagram ", -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_89 = { class: "social-check" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "imputSocialGitHub"
}, " GitHub ", -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_92 = { class: "social-check" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "imputSocialLinkedink"
}, " Linkedin ", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_95 = { class: "social-check" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "imputSocialFacebook"
}, " Facebook ", -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_98 = { class: "right" }
const _hoisted_99 = { class: "social-check" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "imputSocialYoutube"
}, " Youtube ", -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_102 = { class: "social-check" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "imputSocialTikTok"
}, " TikTok ", -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_105 = { class: "social-check" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "imputSocialWeb"
}, " Sitio Web ", -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_108 = { class: "social-check" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "imputSocialOtros"
}, " Otros ", -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Actualizar", -1))
const _hoisted_112 = [
  _hoisted_111
]
const _hoisted_113 = { key: 1 }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_115 = { class: "experience-container" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Experiencia Laboral", -1))
const _hoisted_117 = {
  key: 0,
  class: "experience"
}
const _hoisted_118 = ["onClick"]
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Pulsa para editar / ver más", -1))
const _hoisted_120 = { key: 1 }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_122 = { class: "education-container" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Estudios Previos", -1))
const _hoisted_124 = {
  key: 0,
  class: "experience"
}
const _hoisted_125 = ["onClick"]
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Pulsa para editar / ver más", -1))
const _hoisted_127 = { key: 1 }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_129 = { class: "soft-skills-container" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Habilidades", -1))
const _hoisted_131 = {
  key: 0,
  class: "experience"
}
const _hoisted_132 = { class: "animate skill-card-plus" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "0",
  disabled: ""
}, "Añadir Habilidad", -1))
const _hoisted_134 = ["value"]
const _hoisted_135 = ["onClick"]
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Pulsa para Eliminar", -1))
const _hoisted_137 = { key: 1 }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_139 = { class: "your-certificates" }
const _hoisted_140 = { key: 0 }
const _hoisted_141 = {
  key: 1,
  class: "experience"
}
const _hoisted_142 = { key: 2 }

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { ref, onMounted , Ref} from 'vue'
import EmployProfileService from '@/services/EmployProfileService'
import LocationService from '@/services/LocationService'
import SkillServive from '@/services/SkillService'
import JobCategoryService from '@/services/JobCategoryService'
import PreviousJobService from '@/services/PreviousJobService'
import DiplomaService from '@/services/DiplomaService'
import StudyService from '@/services/StudyService'
import { useAuth } from '@/store/useAuth'
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface';
import router from '@/router'
import PortFolio from '@/services/PortFolioService'
import ProfileI from '@/interfaces/ProfileInterface'
import main from '@/data/main.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'JobProfileView',
  setup(__props) {

const portFolioService = new PortFolio()
const github =ref('')
const instagram = ref('')
const linkedin = ref('')
const facebook = ref('')
const youtube = ref('')
const tiktok = ref('')
const web = ref('')
const other_sn = ref('') 
const slogan = ref('')
const profile_description = ref('')

const selectedSkill = ref(0)
const showAddExperienceModal = ref(false)
const showUpdateExperienceModal = ref(false)
const showUpdateStudyModal = ref(false)
const showAddStudyModal = ref(false)
const loading = ref(true)
const loadingExperience = ref(false)
const loadingStudies = ref(false)
const loadingSkills = ref(false)
const loadingCertifications = ref(false)
const allSkills:Ref<ProfileI[]> = ref([])
const skills:Ref<any> = ref([])
const studies:Ref<any> = ref([])
const experiences:Ref<any> = ref([])
const countries:Ref<ProfileI[]> = ref([])
const certifications:Ref<ProfileI[]> = ref([])
const country = ref(1)
const countryStudy = ref(1)
const locations:Ref<ProfileI[]> = ref([])
const locationsStudy:Ref<ProfileI[]> = ref([])
const jobCategories:Ref<ProfileI[]> = ref([])
const updateExperienceId = ref(0)
const updateStudyId = ref(0)
const profile:Ref<any> = ref({
    is_searching: false,
    automatic_inscription: false,
    available_remote: false,
    available_to_move: false,
    location_id: 32,
    movility_type: 'local'
})
const newExperience:Ref<any> = ref({
    years: 0,
    name: null,
    company: null,
    description: null,
    job_category_id: 0
})
const newStudy:Ref<any> = ref({
    name: null,
    description: null,
    organism: null,
    location_id: 0
})
const feedbackAddExperience = ref("")
const feedbackAddStudy = ref("")
const feedbackUpdateExperience = ref("")
const feedbackUpdateStudy = ref("")
const employProfileService = new EmployProfileService()
const locationService = new LocationService()
const jobCategoryService = new JobCategoryService()
const previousJobService = new PreviousJobService()
const skillService = new SkillServive()
const studyService = new StudyService()
const diplomaService = new DiplomaService()
const toast = useToast()
const store = useAuth()
onMounted(() => LoadProfileInfo())

const LoadProfileInfo = async () => {

    if (store.token == null) {
        loading.value = false
        return
    }

    loading.value = true
    jobCategories.value = await jobCategoryService.getAllJobCategories()
    profile.value = await employProfileService.GetEmployProfileInfo(store.token)
    ProfileParser()
    countries.value = await locationService.GetAllCountries()
    allSkills.value = await skillService.GetAllSkills()
    await SetCountry()
    await LoadLocations()
    await LoadExperience()
    await LoadStudies()
    await LoadSkills()
    await LoadCertificates()
    await LoadLocationsStudy()

    slogan.value =  profile.value.slogan,
    profile_description.value = profile.value.profile_description,
    github.value =profile.value.github,
    instagram.value = profile.value.instagram,
    linkedin.value = profile.value.linkedin,
    facebook.value = profile.value.facebook,
    youtube.value = profile.value.youtube,
    tiktok.value = profile.value.tiktok,
    web.value = profile.value.web,
    other_sn.value = profile.value.other_sn

    loading.value = false
}

const SetCountry = async () => {
    const countryTemp = await locationService.GetCountryByLocationId(profile.value.location_id)
    country.value = countryTemp.id
}

const ProfileParser = () => {

    if (profile.value.is_searching == 1) {
        profile.value.is_searching = true
    } else {
        profile.value.is_searching = false
    }

    if (profile.value.automatic_inscription == 1) {
        profile.value.automatic_inscription = true
    } else {
        profile.value.automatic_inscription = false
    }

    if (profile.value.available_remote == 1) {
        profile.value.available_remote = true
    } else {
        profile.value.available_remote = false
    }

    if (profile.value.available_to_move == 1) {
        profile.value.available_to_move = true
    } else {
        profile.value.available_to_move = false
    }
}

const LoadLocations = async () => {
    locations.value = await locationService.GetLocationsFromCountry(country.value)
}

const LoadLocationsStudy = async () => {
    locationsStudy.value = await locationService.GetLocationsFromCountry(countryStudy.value)
}


const UpdateIsSearching = async () => {
    if (profile.value.is_searching) {
        if(store.token  != null){
        await employProfileService.SetSearchEmploy(store.token)
        }
    } else {
        if(store.token  != null){
        await employProfileService.SetNoSearchEmploy(store.token)
        }
    }
    toast.showToast("Perfil actualizado.", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);
}

const UpdateAutomaticInscription = async () => {
  
    if (profile.value.automatic_inscription) {
        if(!store.token){
        await employProfileService.SetAutoSearchEmploy(store.token)
        }
    } else {
        if(!store.token){
        await employProfileService.SetNoAutoSearchEmploy(store.token)
        }
    }
    toast.showToast("Perfil actualizado.", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);
}

const UpdateAvailableRemote = async () => {
    if (profile.value.available_remote) {
        if(store.token  != null){
        await employProfileService.SetAvailableRemote(store.token)
        }
    } else {
        if(store.token  != null){
        await employProfileService.SetNoAvailableRemote(store.token)
    }
    }
    toast.showToast("Perfil actualizado.", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);
}

const UpdateAvailableToMove = async () => {
    if (profile.value.available_to_move) {
        if(store.token  != null){
        await employProfileService.SetAvailableToMove(store.token)
        }
    } else {
        if(store.token  != null){
        await employProfileService.SetAvailableToMove(store.token)
        }
    }
    toast.showToast("Perfil actualizado.", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);
}

const UpdateLocationId = async () => {
    if(store.token  != null){
    await employProfileService.SetLocation(store.token, profile.value.location_id)
    toast.showToast("Perfil actualizado.", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000)
    }
}


const UpdateMovilityType = async () => {
    if(store.token  != null){
    await employProfileService.SetMovilityType(store.token, profile.value.movility_type)
    toast.showToast("Perfil actualizado.", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000)
    }
}

const OnClickSocial = async () => {
    try {
        if (!store.token) {
            return;
        }
        alert('¡Se han añadido correctamente las redes sociales!')

        await portFolioService.SetSocialStudy(
                store.token,
                github.value,
                instagram.value,
                linkedin.value,
                facebook.value,
                youtube.value,
                tiktok.value,
                web.value,
                other_sn.value);

    } catch (error) {
        console.error('Error al guardar redes sociales', error);
        feedbackAddExperience.value = "Error al guardar redes sociales.";
    }
}
const OnClickAbout = async () => {
    try {
        if (!store.token) {
            return;
        }
        alert('¡Se ha añadido correctamente el apartado Sobre Mí!')
        await portFolioService.SetAboutMe(
            store.token,
            slogan.value, 
            profile_description.value);

    } catch (error) {
        console.error('Error al guardar sobre mí', error);
    }
}

const OnClickStoreNewExperience = async () => {
    try {
        if (!store.token) {
            return;
        }

        feedbackAddExperience.value = "Guardando..."

        await previousJobService.CreateJobToUser(store.token, newExperience.value);

        newExperience.value = {
            years: 0,
            name: null,
            company: null,
            description: null,
            job_category_id: 0
        }
        await LoadExperience()
        feedbackAddExperience.value = ""
        showAddExperienceModal.value = false
    } catch (error) {
        console.error('Error al guardar nueva experiencia:', error);
        feedbackAddExperience.value = "Error al guardar la experiencia.";
    }
}
const OnClickAddSkill = async () => {
    if (!store.token) {
        return;
    }
    if (selectedSkill.value == 0) {
        toast.showToast("Por favor, selecciona una skill.", Toast.WARNING)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }
    await skillService.AddSkillToUser(store.token, selectedSkill.value)
    selectedSkill.value = 0;
    LoadSkills()
}

const OnClickStoreNewStudy = async () => {
    try {
        if (!store.token) {
            return;
        }

        feedbackAddStudy.value = "Guardando..."

        await studyService.CreateStudy(store.token, newStudy.value);

        newStudy.value = {
            name: null,
            description: null,
            organism: null,
            location_id: 0
        }

        await LoadStudies()
        feedbackAddStudy.value = ""
        showAddStudyModal.value = false
    } catch (error) {
        console.error('Error al guardar nuevo estudio:', error);
        feedbackAddStudy.value = "Error al guardar el estudio.";
    }
}

const OnClickShowEditExperience = async (id: number) => {
    if (!store.token) {
        return
    }
    showUpdateExperienceModal.value = true
    updateExperienceId.value = id
    newExperience.value = await previousJobService.GetJobFromUser(store.token, id)
}

const OnClickShowEditStudy = async (id: number) => {
    if (!store.token) {
        return
    }
    showUpdateStudyModal.value = true
    updateStudyId.value = id
    newStudy.value = await studyService.GetStudyFromUser(store.token, id)
}

const OnClickShowAddExperience = () => {
    newExperience.value = {
        years: 0,
        name: null,
        company: null,
        description: null,
        job_category_id: 0
    }
    feedbackAddExperience.value = ""
    showAddExperienceModal.value = true
}

const OnClickShowAddStudy = () => {
    newStudy.value = {
        name: null,
        description: null,
        organism: null,
        location_id: 0
    }
    feedbackAddStudy.value = ""
    showAddStudyModal.value = true
}
const OnClickUpdateExperience = async () => {
    try {
        if (!store.token) {
            return;
        }

        feedbackUpdateExperience.value = "Actualizando..."

        await previousJobService.UpdateJobToUser(store.token, newExperience.value, updateExperienceId.value);

        newExperience.value = {
            years: 0,
            name: null,
            company: null,
            description: null,
            job_category_id: 0
        }
        await LoadExperience()
        feedbackUpdateExperience.value = ""
        showUpdateExperienceModal.value = false
    } catch (error) {
        console.error('Error al actualizar experiencia:', error);
        feedbackUpdateExperience.value = "Error al actualizar la experiencia.";
    }
}

const OnClickUpdateStudy = async () => {
    try {
        if (!store.token) {
            return;
        }

        feedbackUpdateStudy.value = "Actualizando..."

        await studyService.UpdateStudyToUser(store.token, newStudy.value, updateStudyId.value);

        newStudy.value = {
            name: null,
            description: null,
            organism: null,
            location_id: 0
        }
        await LoadStudies()
        feedbackUpdateStudy.value = ""
        showUpdateStudyModal.value = false
    } catch (error) {
        console.error('Error al actualizar estudio:', error);
        feedbackUpdateStudy.value = "Error al actualizar el estudio.";
    }
}

const OnClickDeleteExperience = async () => {
    if (!store.token) {
        return;
    }

    feedbackUpdateExperience.value = "Borrando..."

    await previousJobService.DeleteJobFromUser(store.token, updateExperienceId.value)

    newExperience.value = {
        years: 0,
        name: null,
        company: null,
        description: null,
        job_category_id: 0
    }
    await LoadExperience()
    feedbackUpdateExperience.value = ""
    showUpdateExperienceModal.value = false
}

const OnClickDeleteSkill = async (id: number) => {
    if (!store.token) {
        return;
    }

    await skillService.DeleteSkillToUser(store.token, id)
    LoadSkills()
}

const OnClickDeleteStudy = async () => {
    if (!store.token) {
        return;
    }

    feedbackUpdateStudy.value = "Borrando..."

    await studyService.DeleteJobFromUser(store.token, updateStudyId.value)

    newStudy.value = {
        name: null,
        description: null,
        organism: null,
        location_id: 0
    }
    await LoadStudies()
    feedbackUpdateStudy.value = ""
    showUpdateStudyModal.value = false
}

const LoadExperience = async () => {
    if (!store.token) {
        return;
    }
    loadingExperience.value = true
    experiences.value = await previousJobService.GetAllJobsFromUser(store.token)
    loadingExperience.value = false
}
const LoadStudies = async () => {
    if (!store.token) {
        return;
    }
    loadingStudies.value = true
    studies.value = await studyService.GetAllStudies(store.token)
    loadingStudies.value = false
}
const LoadSkills = async () => {
    if (!store.token) {
        return;
    }
    loadingSkills.value = true
    skills.value = await skillService.GetAllSkillsFromUser(store.token)
    loadingSkills.value = false
}
const LoadCertificates = async () => {
    if (!store.token) {
        return;
    }
    loadingCertifications.value = true
    certifications.value = await diplomaService.getAllDiplomasFromUser(store.token)
    loadingCertifications.value = false
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (showAddExperienceModal.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _hoisted_5,
                _createElementVNode("label", null, [
                  _createTextVNode("Cargo / Puesto "),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "field1",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newExperience.value.name) = $event))
                  }, null, 512), [
                    [_vModelText, newExperience.value.name]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createTextVNode("Compañía "),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "field1",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newExperience.value.company) = $event))
                  }, null, 512), [
                    [_vModelText, newExperience.value.company]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createTextVNode("Años en el puesto "),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    name: "field1",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newExperience.value.years) = $event))
                  }, null, 512), [
                    [_vModelText, newExperience.value.years]
                  ])
                ]),
                _hoisted_6,
                _createElementVNode("label", null, [
                  _createTextVNode("Descripción "),
                  _withDirectives(_createElementVNode("textarea", {
                    name: "field2",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newExperience.value.description) = $event))
                  }, null, 512), [
                    [_vModelText, newExperience.value.description]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createTextVNode("Categoría "),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newExperience.value.job_category_id) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobCategories.value, (jobCategory) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: jobCategory.id,
                        value: jobCategory.id
                      }, _toDisplayString(jobCategory.name), 9, _hoisted_7))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, newExperience.value.job_category_id]
                  ])
                ]),
                _createElementVNode("input", {
                  type: "submit",
                  onClick: OnClickStoreNewExperience
                }),
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (showAddExperienceModal.value = false)),
                  class: "close"
                }, [
                  _createVNode(_component_v_icon, {
                    name: "io-close-circle-sharp",
                    fill: "#c93c3c",
                    scale: "1.5"
                  })
                ]),
                _createElementVNode("p", null, _toDisplayString(feedbackAddExperience.value), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (showUpdateExperienceModal.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _hoisted_12,
                _createElementVNode("label", null, [
                  _createTextVNode("Cargo / Puesto "),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "field1",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newExperience.value.name) = $event))
                  }, null, 512), [
                    [_vModelText, newExperience.value.name]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createTextVNode("Compañía "),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "field1",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((newExperience.value.company) = $event))
                  }, null, 512), [
                    [_vModelText, newExperience.value.company]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createTextVNode("Años en el puesto "),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    name: "field1",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((newExperience.value.years) = $event))
                  }, null, 512), [
                    [_vModelText, newExperience.value.years]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createTextVNode("Descripción "),
                  _withDirectives(_createElementVNode("textarea", {
                    name: "field2",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newExperience.value.description) = $event))
                  }, null, 512), [
                    [_vModelText, newExperience.value.description]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createTextVNode("Categoría "),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((newExperience.value.job_category_id) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobCategories.value, (jobCategory) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: jobCategory.id,
                        value: jobCategory.id
                      }, _toDisplayString(jobCategory.name), 9, _hoisted_13))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, newExperience.value.job_category_id]
                  ])
                ]),
                _createElementVNode("input", {
                  type: "submit",
                  onClick: OnClickUpdateExperience
                }),
                _createElementVNode("input", {
                  type: "submit",
                  onClick: OnClickDeleteExperience,
                  value: "Eliminar",
                  class: "delete-btn"
                }),
                _createElementVNode("button", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (showUpdateExperienceModal.value = false)),
                  class: "close"
                }, [
                  _createVNode(_component_v_icon, {
                    name: "io-close-circle-sharp",
                    fill: "#c93c3c",
                    scale: "1.5"
                  })
                ]),
                _createElementVNode("p", null, _toDisplayString(feedbackUpdateExperience.value), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (showAddStudyModal.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _hoisted_18,
                _createElementVNode("label", null, [
                  _createTextVNode("Título "),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "field1",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((newStudy.value.name) = $event))
                  }, null, 512), [
                    [_vModelText, newStudy.value.name]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createTextVNode("Centro de estudios "),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "field1",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((newStudy.value.organism) = $event))
                  }, null, 512), [
                    [_vModelText, newStudy.value.organism]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createTextVNode("Descripción "),
                  _withDirectives(_createElementVNode("textarea", {
                    name: "field2",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((newStudy.value.description) = $event))
                  }, null, 512), [
                    [_vModelText, newStudy.value.description]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createTextVNode("Ubicación "),
                  _withDirectives(_createElementVNode("select", {
                    class: "part",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((countryStudy).value = $event)),
                    onChange: LoadLocationsStudy,
                    placeholder: "País",
                    style: {"margin-bottom":"5px"}
                  }, [
                    _hoisted_19,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countries.value, (country) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: country.id,
                        value: country.id
                      }, _toDisplayString(country.name), 9, _hoisted_20))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, countryStudy.value]
                  ]),
                  _createTextVNode(),
                  _withDirectives(_createElementVNode("select", {
                    class: "part",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((newStudy.value.location_id) = $event)),
                    placeholder: "Región"
                  }, [
                    _hoisted_21,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationsStudy.value, (location) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: location.id,
                        value: location.id
                      }, _toDisplayString(location.name), 9, _hoisted_22))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, newStudy.value.location_id]
                  ])
                ]),
                _createElementVNode("input", {
                  type: "submit",
                  onClick: OnClickStoreNewStudy
                }),
                _createElementVNode("button", {
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (showAddStudyModal.value = false)),
                  class: "close"
                }, [
                  _createVNode(_component_v_icon, {
                    name: "io-close-circle-sharp",
                    fill: "#c93c3c",
                    scale: "1.5"
                  })
                ]),
                _createElementVNode("p", null, _toDisplayString(feedbackAddStudy.value), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (showUpdateStudyModal.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _hoisted_27,
                _createElementVNode("label", null, [
                  _createTextVNode("Título "),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "field1",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((newStudy.value.name) = $event))
                  }, null, 512), [
                    [_vModelText, newStudy.value.name]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createTextVNode("Centro de estudios "),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "field1",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((newStudy.value.organism) = $event))
                  }, null, 512), [
                    [_vModelText, newStudy.value.organism]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createTextVNode("Descripción "),
                  _withDirectives(_createElementVNode("textarea", {
                    name: "field2",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((newStudy.value.description) = $event))
                  }, null, 512), [
                    [_vModelText, newStudy.value.description]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createTextVNode("Ubicación "),
                  _withDirectives(_createElementVNode("select", {
                    class: "part",
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((countryStudy).value = $event)),
                    onChange: LoadLocationsStudy,
                    placeholder: "País",
                    style: {"margin-bottom":"5px"}
                  }, [
                    _hoisted_28,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countries.value, (country) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: country.id,
                        value: country.id
                      }, _toDisplayString(country.name), 9, _hoisted_29))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, countryStudy.value]
                  ]),
                  _createTextVNode(),
                  _withDirectives(_createElementVNode("select", {
                    class: "part",
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((newStudy.value.location_id) = $event)),
                    placeholder: "Región"
                  }, [
                    _hoisted_30,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationsStudy.value, (location) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: location.id,
                        value: location.id
                      }, _toDisplayString(location.name), 9, _hoisted_31))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, newStudy.value.location_id]
                  ])
                ]),
                _createElementVNode("input", {
                  type: "submit",
                  onClick: OnClickUpdateStudy
                }),
                _createElementVNode("input", {
                  type: "submit",
                  onClick: OnClickDeleteStudy,
                  value: "Eliminar",
                  class: "delete-btn"
                }),
                _createElementVNode("button", {
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (showUpdateStudyModal.value = false)),
                  class: "close"
                }, [
                  _createVNode(_component_v_icon, {
                    name: "io-close-circle-sharp",
                    fill: "#c93c3c",
                    scale: "1.5"
                  })
                ]),
                _createElementVNode("p", null, _toDisplayString(feedbackUpdateStudy.value), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_32,
      _hoisted_33,
      _hoisted_34,
      _createElementVNode("div", _hoisted_35, [
        _hoisted_36,
        (!loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  value: "",
                  id: "flexCheckDefault",
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((profile.value.is_searching) = $event)),
                  onChange: UpdateIsSearching,
                  style: _normalizeStyle({'background-color': _unref(main).THIRD_COLOR})
                }, null, 36), [
                  [_vModelCheckbox, profile.value.is_searching]
                ]),
                _hoisted_39
              ]),
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  value: "",
                  id: "flexCheckDefault",
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((profile.value.automatic_inscription) = $event)),
                  onChange: UpdateAutomaticInscription
                }, null, 544), [
                  [_vModelCheckbox, profile.value.automatic_inscription]
                ]),
                _hoisted_42
              ]),
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  value: "",
                  id: "flexCheckDefault",
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((profile.value.available_remote) = $event)),
                  onChange: UpdateAvailableRemote
                }, null, 544), [
                  [_vModelCheckbox, profile.value.available_remote]
                ]),
                _hoisted_45
              ]),
              _hoisted_46,
              _createElementVNode("div", _hoisted_47, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  value: "",
                  id: "flexCheckDefault",
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((profile.value.available_to_move) = $event)),
                  onChange: UpdateAvailableToMove
                }, null, 544), [
                  [_vModelCheckbox, profile.value.available_to_move]
                ]),
                _hoisted_48
              ]),
              _hoisted_49,
              (profile.value.available_to_move)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _hoisted_51,
                    _hoisted_52,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select move",
                      "aria-label": "Default select example",
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((profile.value.movility_type) = $event)),
                      onChange: UpdateMovilityType
                    }, _hoisted_57, 544), [
                      [_vModelSelect, profile.value.movility_type]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_58,
              _hoisted_59,
              _createElementVNode("div", _hoisted_60, [
                _withDirectives(_createElementVNode("select", {
                  class: "part",
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((country).value = $event)),
                  onChange: LoadLocations,
                  placeholder: "País"
                }, [
                  _hoisted_61,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countries.value, (country) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: country.id,
                      value: country.id
                    }, _toDisplayString(country.name), 9, _hoisted_62))
                  }), 128))
                ], 544), [
                  [_vModelSelect, country.value]
                ]),
                _createTextVNode(),
                _withDirectives(_createElementVNode("select", {
                  class: "part",
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((profile.value.location_id) = $event)),
                  placeholder: "Región",
                  onChange: UpdateLocationId
                }, [
                  _hoisted_63,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locations.value, (location) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: location.id,
                      value: location.id
                    }, _toDisplayString(location.name), 9, _hoisted_64))
                  }), 128))
                ], 544), [
                  [_vModelSelect, profile.value.location_id]
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_65, [
              _createVNode(_component_v_icon, {
                name: "ri-loader-2-fill",
                animation: "spin",
                class: "icon",
                scale: "2"
              })
            ]))
      ]),
      _hoisted_66,
      _createElementVNode("div", _hoisted_67, [
        _hoisted_68,
        (!loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _hoisted_73,
                    _withDirectives(_createElementVNode("input", {
                      class: "input-social",
                      type: "text",
                      id: "imputSocialSlogan",
                      placeholder: "Ejemplo : Desarrollador Web",
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((slogan).value = $event))
                    }, null, 512), [
                      [_vModelText, slogan.value]
                    ])
                  ]),
                  _hoisted_74,
                  _createElementVNode("div", _hoisted_75, [
                    _hoisted_76,
                    _withDirectives(_createElementVNode("textarea", {
                      class: "input-social",
                      type: "text",
                      id: "imputSocialGitHub",
                      cols: "30",
                      rows: "10",
                      placeholder: "Soy un apasionado del desarrollo web ... máximo 4.000 carácteres",
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((profile_description).value = $event))
                    }, null, 512), [
                      [_vModelText, profile_description.value]
                    ])
                  ]),
                  _hoisted_77,
                  _createElementVNode("button", {
                    class: "btn-info",
                    onClick: _cache[33] || (_cache[33] = ($event: any) => (OnClickAbout()))
                  }, _hoisted_79)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_80, [
              _createVNode(_component_v_icon, {
                name: "ri-loader-2-fill",
                animation: "spin",
                class: "icon",
                scale: "2"
              })
            ]))
      ]),
      _createElementVNode("div", _hoisted_81, [
        _hoisted_82,
        (!loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", _hoisted_86, [
                    _hoisted_87,
                    _withDirectives(_createElementVNode("input", {
                      class: "input-social",
                      type: "text",
                      id: "imputSocialInstagram",
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((instagram).value = $event)),
                      placeholder: "Si no tienes, dejar vacío"
                    }, null, 512), [
                      [_vModelText, instagram.value]
                    ])
                  ]),
                  _hoisted_88,
                  _createElementVNode("div", _hoisted_89, [
                    _hoisted_90,
                    _withDirectives(_createElementVNode("input", {
                      class: "input-social",
                      type: "text",
                      id: "imputSocialGitHub",
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((github).value = $event)),
                      placeholder: "Si no tienes, dejar vacío"
                    }, null, 512), [
                      [_vModelText, github.value]
                    ])
                  ]),
                  _hoisted_91,
                  _createElementVNode("div", _hoisted_92, [
                    _hoisted_93,
                    _withDirectives(_createElementVNode("input", {
                      class: "input-social",
                      type: "text",
                      id: "imputSocialLinkedink",
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((linkedin).value = $event)),
                      placeholder: "Si no tienes, dejar vacío"
                    }, null, 512), [
                      [_vModelText, linkedin.value]
                    ])
                  ]),
                  _hoisted_94,
                  _createElementVNode("div", _hoisted_95, [
                    _hoisted_96,
                    _withDirectives(_createElementVNode("input", {
                      class: "input-social",
                      type: "text",
                      id: "imputSocialFacebook",
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((facebook).value = $event)),
                      placeholder: "Si no tienes, dejar vacío"
                    }, null, 512), [
                      [_vModelText, facebook.value]
                    ])
                  ])
                ]),
                _hoisted_97,
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("div", _hoisted_99, [
                    _hoisted_100,
                    _withDirectives(_createElementVNode("input", {
                      class: "input-social",
                      type: "text",
                      id: "imputSocialYoutube",
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((youtube).value = $event)),
                      placeholder: "Si no tienes, dejar vacío"
                    }, null, 512), [
                      [_vModelText, youtube.value]
                    ])
                  ]),
                  _hoisted_101,
                  _createElementVNode("div", _hoisted_102, [
                    _hoisted_103,
                    _withDirectives(_createElementVNode("input", {
                      class: "input-social",
                      type: "text",
                      id: "imputSocialTikTok",
                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((tiktok).value = $event)),
                      placeholder: "Si no tienes, dejar vacío"
                    }, null, 512), [
                      [_vModelText, tiktok.value]
                    ])
                  ]),
                  _hoisted_104,
                  _createElementVNode("div", _hoisted_105, [
                    _hoisted_106,
                    _withDirectives(_createElementVNode("input", {
                      class: "input-social",
                      type: "text",
                      id: "imputSocialWeb",
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((web).value = $event)),
                      placeholder: "Si no tienes, dejar vacío"
                    }, null, 512), [
                      [_vModelText, web.value]
                    ])
                  ]),
                  _hoisted_107,
                  _createElementVNode("div", _hoisted_108, [
                    _hoisted_109,
                    _withDirectives(_createElementVNode("input", {
                      class: "input-social",
                      type: "text",
                      id: "imputSocialOtros",
                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((other_sn).value = $event)),
                      placeholder: "Si no tienes, dejar vacío"
                    }, null, 512), [
                      [_vModelText, other_sn.value]
                    ])
                  ])
                ])
              ]),
              _hoisted_110,
              _createElementVNode("button", {
                class: "btn-info",
                onClick: _cache[42] || (_cache[42] = ($event: any) => (OnClickSocial()))
              }, _hoisted_112)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_113, [
              _createVNode(_component_v_icon, {
                name: "ri-loader-2-fill",
                animation: "spin",
                class: "icon",
                scale: "2"
              })
            ]))
      ]),
      _hoisted_114,
      _createElementVNode("div", _hoisted_115, [
        _hoisted_116,
        (!loadingExperience.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
              _createElementVNode("div", {
                class: "experience-card-plus",
                onClick: OnClickShowAddExperience
              }, [
                _createVNode(_component_v_icon, {
                  name: "bi-plus-square-dotted",
                  scale: "3",
                  fill: _unref(main).THIRD_COLOR
                }, null, 8, ["fill"])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(experiences.value, (experience) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "experience-card",
                  key: experience.id,
                  onClick: ($event: any) => (OnClickShowEditExperience(experience.id))
                }, [
                  _createElementVNode("h5", null, _toDisplayString(experience.years) + " años como " + _toDisplayString(experience.name) + " en " + _toDisplayString(experience.company), 1),
                  _hoisted_119
                ], 8, _hoisted_118))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_120, [
              _createVNode(_component_v_icon, {
                name: "ri-loader-2-fill",
                animation: "spin",
                class: "icon",
                scale: "2"
              })
            ]))
      ]),
      _hoisted_121,
      _createElementVNode("div", _hoisted_122, [
        _hoisted_123,
        (!loadingStudies.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
              _createElementVNode("div", {
                class: "animate experience-card-plus",
                onClick: OnClickShowAddStudy
              }, [
                _createVNode(_component_v_icon, {
                  name: "bi-plus-square-dotted",
                  scale: "3",
                  fill: _unref(main).THIRD_COLOR
                }, null, 8, ["fill"])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(studies.value, (study) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "animate experience-card",
                  key: study.id,
                  onClick: ($event: any) => (OnClickShowEditStudy(study.id))
                }, [
                  _createElementVNode("h5", null, _toDisplayString(study.name) + " en " + _toDisplayString(study.organism), 1),
                  _hoisted_126
                ], 8, _hoisted_125))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_127, [
              _createVNode(_component_v_icon, {
                name: "ri-loader-2-fill",
                animation: "spin",
                class: "icon",
                scale: "2"
              })
            ]))
      ]),
      _hoisted_128,
      _createElementVNode("div", _hoisted_129, [
        _hoisted_130,
        (!loadingSkills.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
              _createElementVNode("div", _hoisted_132, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((selectedSkill).value = $event)),
                  class: "addSkillSelect"
                }, [
                  _hoisted_133,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allSkills.value, (skill) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: skill.id,
                      value: skill.id
                    }, _toDisplayString(skill.name), 9, _hoisted_134))
                  }), 128))
                ], 512), [
                  [_vModelSelect, selectedSkill.value]
                ]),
                _createElementVNode("input", {
                  type: "submit",
                  onClick: OnClickAddSkill,
                  value: "Añadir",
                  class: "add-skill"
                })
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skills.value, (skill) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "animate experience-card",
                  key: skill.id,
                  onClick: ($event: any) => (OnClickDeleteSkill(skill.id))
                }, [
                  _createElementVNode("h5", null, _toDisplayString(skill.name), 1),
                  _hoisted_136
                ], 8, _hoisted_135))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_137, [
              _createVNode(_component_v_icon, {
                name: "ri-loader-2-fill",
                animation: "spin",
                class: "icon",
                scale: "2"
              })
            ]))
      ]),
      _hoisted_138,
      _createElementVNode("div", _hoisted_139, [
        (certifications.value.length >= 1)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_140, "Certificaciones Ademass"))
          : _createCommentVNode("", true),
        (!loadingCertifications.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(certifications.value, (certification) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "animate experience-card-green",
                  key: certification.id,
                  onClick: _cache[44] || (_cache[44] = ($event: any) => (_unref(router).push({
                        name: 'my-diplomas'
                    })))
                }, [
                  _createElementVNode("h5", null, _toDisplayString(certification.name), 1)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_142, [
              _createVNode(_component_v_icon, {
                name: "ri-loader-2-fill",
                animation: "spin",
                class: "icon",
                scale: "2"
              })
            ]))
      ])
    ]),
    _: 1
  }))
}
}

})